// extracted by mini-css-extract-plugin
export default {"premium-badge":"styles-module__premium-badge___Ik2CR","silver":"styles-module__silver___ho_v3","gold":"styles-module__gold___OqbPC","platinum":"styles-module__platinum___y2Vkq"};